import { BrowserRouter, Routes, Route } from "react-router-dom";
// import "bootstrap/dist/css/bootstrap.min.css ";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";

import IEC from "./pages/dgft/IEC";
import License from "./pages/dgft/License";
import DGFTPage from "./pages/DGFTPage";
import RestrictedImportPage from "./pages/dgft/RestrictedImportPage";
import RestrictedExportPage from "./pages/dgft/RestrictedExportPage";
import ScometAuthorisation from "./pages/dgft/ScometAuthorisation";
import StatusHouseCertification from "./pages/dgft/StatusHouseCertification";
import RODTEP from "./pages/dgft/RODTEP";
import MEIS from "./pages/dgft/MEIS";
import SEIS from "./pages/dgft/SEIS";
import AdvanceAuthorisation from "./pages/dgft/AA";
import DFIAlicence from "./pages/dgft/DFIAlicence";
import EPCG from "./pages/dgft/EPCG";
import EXIM from "./pages/dgft/EXIM";
import AEO from "./pages/dgft/AEO";
import IEM from "./pages/dgft/IEM";
import RCMC from "./pages/dgft/RCMC";
import Token from "./pages/dgft/Token";
import TMA from "./pages/dgft/TMA";
import SIMS from "./pages/dgft/SIMS";
import CIMS from "./pages/dgft/CIMS";
import CAIMS from "./pages/dgft/CAIMS";
import CHIP from "./pages/dgft/CHIP";
import COO from "./pages/dgft/COO";
import PIMS from "./pages/dgft/PIMS";

import IndustrialSubsidyPage from "./pages/IndustrialSubsidyPage";
import MFP from "./pages/subsidy/MFP";
import APC from "./pages/subsidy/APC";
import CBFL from "./pages/subsidy/CBFL";
import FTL from "./pages/subsidy/FTL";
import CEFPC from "./pages/subsidy/CEFPPC";
import CHOP from "./pages/subsidy/CHOpen";
import NHM from "./pages/subsidy/NHM";
import CHPC from "./pages/subsidy/CHPC";
import Cold from "./pages/subsidy/Cold";
import IPH from "./pages/subsidy/IPH";
import NHB from "./pages/subsidy/NHB";
import OG from "./pages/subsidy/OG";
import TelanganaFood from "./pages/subsidy/TSFPP";
import AIF from "./pages/subsidy/AIF";
import MSME from "./pages/subsidy/MSME";
import AMI from "./pages/subsidy/AMI ";
import NIM from "./pages/subsidy/NIM";
import NSC from "./pages/subsidy/NSC";
import APEDA from "./pages/subsidy/APEDA";
import SFAC from "./pages/subsidy/SFAC";
import SudsidyCal from "./pages/SubsidyCal";

import MoowrScheme from "./pages/MoowrScheme";
import State from "./pages/subsidy/State";
import Central from "./pages/subsidy/Central";

import Consulting from "./pages/Consulting";

function App() {
  return (
    <BrowserRouter>
      {/* Top Menu */}
      <Navbar />

      {/* Page Content */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />

        {/* DGFT */}
        <Route path="/dgft/iec" element={<IEC />} />
        <Route path="/dgft/license" element={<License />} />
        <Route path="/dgft" element={<DGFTPage />} />
        <Route
          path="/dgft/restricted-import"
          element={<RestrictedImportPage />}
        />
        <Route
          path="/dgft/restricted-export"
          element={<RestrictedExportPage />}
        />
        <Route path="/dgft/scomet" element={<ScometAuthorisation />} />
        <Route
          path="/dgft/status-house"
          element={<StatusHouseCertification />}
        />
        <Route path="/dgft/rodtep" element={<RODTEP />} />
        <Route path="/dgft/meis" element={<MEIS />} />
        <Route path="/dgft/seis" element={<SEIS />} />
        <Route path="/dgft/advance" element={<AdvanceAuthorisation />} />
        <Route path="/dgft/dfia" element={<DFIAlicence />} />
        <Route path="/dgft/epcg" element={<EPCG />} />
        <Route path="/dgft/exim" element={<EXIM />} />
        <Route path="/dgft/aeo" element={<AEO />} />
        <Route path="/dgft/iem" element={<IEM />} />
        <Route path="/dgft/rcmc" element={<RCMC />} />

        <Route path="/dgft/token" element={<Token />} />
        <Route path="/dgft/tma" element={<TMA />} />
        <Route path="/dgft/sims" element={<SIMS />} />
        <Route path="/dgft/cims" element={<CIMS />} />
        <Route path="/dgft/caims" element={<CAIMS />} />
        <Route path="/dgft/chip" element={<CHIP />} />
        <Route path="/dgft/coo" element={<COO />} />

        <Route path="/dgft/pims" element={<PIMS />} />
        <Route path="/dgft/intro" element={<DGFTPage />} />

        {/* Subsidy */}
        <Route
          path="/industrial-subsidies"
          element={<IndustrialSubsidyPage />}
        />
        <Route path="/subsidy/state" element={<State />} />
        <Route path="/subsidy/central" element={<Central />} />
        <Route path="/subsidy/mega-food-park" element={<MFP />} />
        <Route path="/subsidy/apc" element={<APC />} />
        <Route path="/subsidy/cbfl" element={<CBFL />} />
        <Route path="/subsidy/ftl" element={<FTL />} />
        <Route path="/subsidy/cefppc" element={<CEFPC />} />
        <Route path="/subsidy/open-field" element={<CHOP />} />
        <Route path="/subsidy/cold-storage" element={<NHM />} />
        <Route path="/subsidy/protected-cover" element={<CHPC />} />
        <Route path="/subsidy/cold-chain" element={<Cold />} />
        <Route path="/subsidy/post-harvest" element={<IPH />} />
        <Route path="/subsidy/cluster" element={<NHB />} />
        <Route path="/subsidy/operation-greens" element={<OG />} />
        <Route path="/subsidy/telangana-food" element={<TelanganaFood />} />
        <Route path="/subsidy/aif" element={<AIF />} />
        <Route path="/subsidy/clcss" element={<MSME />} />
        <Route path="//subsidy/ami" element={<AMI />} />
        <Route path="/subsidy/poultry" element={<NIM />} />
        <Route path="/subsidy/nsc" element={<NSC />} />
        <Route path="/subsidy/apeda" element={<APEDA />} />
        <Route path="/subsidy/sfac" element={<SFAC />} />

        {/* Other */}
        <Route path="/subsidycal" element={<SudsidyCal />} />
        <Route path="/moowr" element={<MoowrScheme />} />
        <Route path="/consulting" element={<Consulting />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>

      <a
        href="https://wa.me/917207757511?text=Hello"
        className="whatsapp-float"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src="https://cdn-icons-png.flaticon.com/512/733/733585.png"
          alt="WhatsApp"
        />
      </a>

      {/* Bottom Footer */}
      <Footer />
    </BrowserRouter>
  );
}

export default App;
